@if (brandingService.darkModeEnabled && isLoggedIn && environment.defaultTheme !== 'dark') {
  <link
    [href]="darkModeUrl"
    rel="stylesheet"
    type="text/css"
    />
}
@if (!brandingService.darkModeEnabled && isLoggedIn && environment.defaultTheme === 'dark') {
  <link
    [href]="lightModeUrl"
    rel="stylesheet"
    type="text/css"
    />
}
<main
  (mouseenter)="close()"
    [ngClass]="{
        open: isNavOpen && !pageIsUnauthed,
        shaded: isShaded,
        experimental: featureService.experimentalFeatures,
        newNav: !featureService.disableNewNavigation,
        noPad: !isLoggedIn || noPadding,
        fullScreen: hideSideBar,
        shadeBackground: isShadeBackground,
        darkmode: brandingService.darkModeEnabled && isLoggedIn,
        cardWarning: isLoggedIn && !billingEnabledService.hideCardWarning && billingEnabledService.isFourteenDayTrial
    }"
  >
  <app-banner-message
    [isLoggedIn]="isLoggedIn"
    [message]="bannerMessage"
    [isVisible]="showBanner"
    [showSupportLink]="showSupportLink"
    [buttonText]="bannerButtonText"
    (buttonClicked)="bannerButtonClicked()"
    [showSpinner]="showBannerSpinner"
  ></app-banner-message>
  <app-banner-message
    [ngClass]="{one: !showBanner, two: showBanner }"
    id="ProcessBanner"
    [isLoggedIn]="isLoggedIn"
    [message]="processBannerMessage"
    [isVisible]="showProcessBanner"
    [showSupportLink]="true"
    [buttonText]="'Click here to view more details'"
    (buttonClicked)="processBannerButtonClicked()"
    (closeClicked)="processBannerClosed()"
  ></app-banner-message>
  @if (isLoggedIn && !billingEnabledService.hideCardWarning && billingEnabledService.isFourteenDayTrial) {
    <div
      class="creditCardWarningContainer"
      >
      <app-credit-card-warning (close)="closeWarning()" class="creditCardWarning"></app-credit-card-warning>
    </div>
  }

  @if (isLoggedIn && isHeader) {
    <app-list-header
      [actionTitle]="actionTitle"
      [breadcrumb]="breadcrumb"
      [hasAzureSubscription]="hasAzureSubscription"
      [hideSubscriptionsTab]="true"
      [hideRoleTemplatesTab]="true"
      [network]="currentNetwork"
      [organization]="currentOrg"
      [resourceType]="resourceType"
      [shortBreadCrumbs]="shortBreadCrumbs"
      [tabs]="tabs"
      [title]="subtitle"
      [url]="url"
    ></app-list-header>
  }
  @if (isFilterable && isLoggedIn && !hideLegacySearch) {
    <app-side-filter
      [isTimeSearchAvailable]="isTimeSearchAvailable"
      [isNotDialLogs]="isNotDialLogs"
    ></app-side-filter>
  }
  <router-outlet></router-outlet>
</main>
<app-loading-indicator [isLoading]="(appLoading && login.isLoggedIn) || login.loginProcessing"></app-loading-indicator>
@if (isLoggedIn && !hideSideBar) {
  <app-side-buttonbar (showGrowlersEvent)="showGrowlers()"></app-side-buttonbar>
}
@if (isLoggedIn && !hideSideBar && !pageIsUnauthed && featureService.disableNewNavigation) {
  <app-side-navigation
    (addEvent)="showWizard()"
    (mouseenter)="removeClose()"
  ></app-side-navigation>
}
@if (isLoggedIn && !hideSideBar && !pageIsUnauthed && !featureService.disableNewNavigation) {
  <app-side-navigator (mouseenter)="removeClose()"></app-side-navigator>
}
@if (isLoggedIn) {
  <app-page-tour></app-page-tour>
}
<app-growler></app-growler>
@if (isLoggedIn) {
  <app-recent-alerts
    (hideGrowlersEvent)="closeGrowlers()"
    [currentNetwork]="currentNetwork"
    [isOpen]="isGrowlersOpen"
  ></app-recent-alerts>
}

@if (showQuickStart && this.featureService.showGettingStarted) {
  <div
    class="QuickStart"
    routerLink="/getting-started"
  ></div>
}
@if (apiService.tutorialActive) {
  <app-progress-bar></app-progress-bar>
}
